/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BetInSchema } from '../models/BetInSchema';
import type { BetSchema } from '../models/BetSchema';
import type { MatchWithBetSchema } from '../models/MatchWithBetSchema';
import type { TournamentDataSchema } from '../models/TournamentDataSchema';
import type { TournamentPredictionOut } from '../models/TournamentPredictionOut';
import type { TournamentToggleIn } from '../models/TournamentToggleIn';
import type { UserScoreSchema } from '../models/UserScoreSchema';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BetsService {

    /**
     * Create Bet
     * @param requestBody
     * @returns BetSchema OK
     * @throws ApiError
     */
    public static createBet(
        requestBody: BetInSchema,
    ): CancelablePromise<BetSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/bets',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Update Bet
     * @param betId
     * @param requestBody
     * @returns BetSchema OK
     * @throws ApiError
     */
    public static updateBet(
        betId: string,
        requestBody: BetInSchema,
    ): CancelablePromise<BetSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/bets/{bet_id}',
            path: {
                'bet_id': betId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Get Leaderboard
     * @returns UserScoreSchema OK
     * @throws ApiError
     */
    public static getLeaderboard(): CancelablePromise<Array<UserScoreSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/bets/',
        });
    }

    /**
     * Get User Score
     * @returns UserScoreSchema OK
     * @throws ApiError
     */
    public static getUserScore(): CancelablePromise<UserScoreSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/bets/me/',
        });
    }

    /**
     * Tournament Data
     * @returns TournamentDataSchema OK
     * @throws ApiError
     */
    public static tournamentData(): CancelablePromise<TournamentDataSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/bets/tournament/data',
        });
    }

    /**
     * Tournament Predictions
     * @returns TournamentPredictionOut OK
     * @throws ApiError
     */
    public static tournamentPredictions(): CancelablePromise<Array<TournamentPredictionOut>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/bets/tournament/predictions',
        });
    }

    /**
     * Tournament Results
     * Реальные результаты турнира по стадиям.
     * @returns any OK
     * @throws ApiError
     */
    public static tournamentResults(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/bets/tournament/results',
        });
    }

    /**
     * Tournament Toggle
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static tournamentToggle(
        requestBody: TournamentToggleIn,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/bets/tournament/toggle',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * User Profile
     * Профиль пользователя.
     * @param userId
     * @returns UserScoreSchema OK
     * @throws ApiError
     */
    public static userProfile(
        userId: number,
    ): CancelablePromise<UserScoreSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/bets/user/{user_id}',
            path: {
                'user_id': userId,
            },
        });
    }

    /**
     * User Bets
     * Прогнозы пользователя на матчи.
     * @param userId
     * @returns MatchWithBetSchema OK
     * @throws ApiError
     */
    public static userBets(
        userId: number,
    ): CancelablePromise<Array<MatchWithBetSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/bets/user/{user_id}/bets',
            path: {
                'user_id': userId,
            },
        });
    }

    /**
     * User Tournament
     * Турнирные прогнозы пользователя.
     * @param userId
     * @returns TournamentPredictionOut OK
     * @throws ApiError
     */
    public static userTournament(
        userId: number,
    ): CancelablePromise<Array<TournamentPredictionOut>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/bets/user/{user_id}/tournament',
            path: {
                'user_id': userId,
            },
        });
    }

}
